module.exports = __webpack_public_path__ + "static/nuces-69feb01fbcc4fcdda65890a8ce987c97.png";